import http, { newAxiosWithJwt } from "../../http-common";

export async function agentFetchVehicles(user) {
  return newAxiosWithJwt(user).get("/agent/co2savers");
}
